import { createSlice } from '@reduxjs/toolkit';

export const associatedBankSlice = createSlice({
    name: 'associated_bank',
    initialState: {
        associated_bank_list: [],
        associated_bank_select: []
    },
    reducers: {
        setAssociatedBankRedux: ( state, { payload } ) => {
            state.associated_bank_list  =  payload;
        },
        setBancosSelectRedux: ( state, { payload } ) => {
            state.associated_bank_select  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setAssociatedBankRedux, setBancosSelectRedux } = associatedBankSlice.actions;